import { render } from "./MaintenanceSection.vue?vue&type=template&id=1703fd84"
import script from "./MaintenanceSection.vue?vue&type=script&lang=js"
export * from "./MaintenanceSection.vue?vue&type=script&lang=js"

import exportComponent from "/codebuild/output/src991838332/src/git-codecommit.ap-northeast-1.amazonaws.com/v1/repos/splats-mypage-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__